module.exports = __webpack_public_path__ + "img/downx2.27dd9b5f.svg";